import { getOptions, postOptions } from '../../apis/option';
import { OPTION } from '../mutation-types';

export const state = {
  option: [],
};
export const getters = {
  option: state => state.option,
};
export const mutations = {
  [OPTION.GET_OPTION](state, res) {
    if (!res.err) {
      state.option = res;
    }
  },
  [OPTION.POST_OPTION](state, res) {
    if (!res.err) {
      res.forEach(opt => {
        const systemId = opt.system_mail_type_id;
        const receiveEmail = opt.receive_email;
        state.option = state.option.map(item => {
          return (item.system_mail_type_id === systemId ? { ...item, receive_email: receiveEmail } : item);
        });
      });
    }
  }
};
export const actions = {
  async getOptions({ commit }) {
    const res = await getOptions();
    commit(OPTION.GET_OPTION, res);
  },
  async postOptions({ commit }, payload) {
    const res = await postOptions(payload);
    commit(OPTION.POST_OPTION, res);
  }
};
